import {makeStyles} from "@material-ui/core/styles";
import {useDispatch, useSelector} from "../../store";
import React, {useEffect, useState} from "react";
import {withExplorer} from "../../layout/Explorer";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Typography from '@material-ui/core/Typography';
import Form from "../../lib/appfuse-react/component/Form";
import {Checkbox, FormControlLabel, FormGroup, Grid, InputAdornment, TextField, useTheme} from "@material-ui/core";
import Button from "../../lib/appfuse-react/component/Button";
import clsx from "clsx";
import Box from "../../lib/appfuse-react/component/Box";
import i18n from "../../lib/appfuse-react/core/i18n";
import usePrompt from "../../lib/appfuse-react/hook/usePrompt";
import UserEvent from "../../lib/appfuse-react/core/UserEvent";
import registrationService from "../../service/iam/registrationService";
import {selectRegistrationForm, setRegistrationForm} from "../../reducer/iam/registrationReducer";
import useRouter from "../../lib/appfuse-react/hook/useRouter";
import {HomeImage} from "../Home";
import Paper from "../../lib/appfuse-react/component/Paper";
import {selectCounty, setCounty} from "../../reducer/util/utilReducer";
import lang from "../../lib/appfuse-react/core/lang";
import utilService from "../../service/util/utilService";
import SelectField from "../../lib/appfuse-react/component/SelectField";
import {useHistory} from "react-router-dom";
import authService from "../../service/iam/authService";
import IconButton from "@material-ui/core/IconButton";
import {Visibility, VisibilityOff} from "@material-ui/icons";
import useResponsive from "../../lib/appfuse-react/hook/useResponsive";
import enrollmentService from "../../service/enrollment/enrollmentService";
import RichText from "../../lib/appfuse-react/component/RichText";
import Space from "../../lib/appfuse-react/component/Space";

const useStyles = makeStyles((theme) => ({
    form: {
        width: '35%',
        maxWidth: '32rem',
        minWidth: '24rem',
        padding: `${theme.spacing(3)}px`,
        display: 'flex',
        flexDirection: 'column',
        gap: `${theme.spacing(2)}px`
    },
    stepper: {
        width: '25%'
    },
    transparent: {
        opacity: 0.95,
        filter: 'drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.7))',
    },
    buttons: {
        '& > *:not(:first-child)': {
            marginLeft: theme.spacing(1)
        },
        height: '100%'
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    typography: {
        paddingBottom: theme.spacing(0),
        marginBottom: theme.spacing(-1)
    }
}));

const STEPS = ['Release of Personal Information Agreement', 'Create your account', 'Tell us more about yourself', 'Verify your email address'];
const FORMS = [RegistrationForm_0, RegistrationForm_1, RegistrationForm_2, RegistrationForm_3];
const validateData = [
    [],
    ['chineseName', 'englishFirstName', 'englishLastName', 'email', 'password', 'confirmPassword'],
    ['mobilePhone', 'mailingAddress']
];

function getStepContent(step) {
    switch (step) {
        case 0:
            return `Please read the following terms and conditions carefully and click the Agree button to continue.`;
        case 1:
            return `Please enter your email and password to start to create your account.`;
        case 2:
            return 'Please provide us with your contact information.';
        case 3:
            return `Click the send button to get the verification code, then enter the verification code sent to your email address and click the verify button.`;
        default:
            return 'Unknown step';
    }
}

function Registration(props) {
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const value = useSelector(selectRegistrationForm);
    const dispatch = useDispatch();
    const router = useRouter();
    const history = useHistory();
    const prompt = usePrompt();
    const theme = useTheme();
    const county = useSelector(selectCounty);

    useEffect(() => {
        (async () => {
            if(lang.isEmpty(county)) {
                const data = await utilService.findCounty();
                dispatch(setCounty(data));
            }
        })();
    }, []);

    const handleChange = (event) => {
        dispatch(setRegistrationForm(event.value));
    };

    const getValidateData = () => {
        let result = {};
        for(let i=0; i<=activeStep; i++) {
            result = validateData[i].reduce((result, key) => ({...result, [key]: value[key]||null}), result);
        }
        return result;
    };
    const handleNext = async () => {
        try {
            await registrationService.validate(getValidateData());
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        } catch (e) {
            prompt.alert(e, {title:'Invalid input.'});
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleComplete = async () => {
        try {
            const authorization = await registrationService.complete(value);
            prompt.confirm('You Have Successfully Registered.', {
                title: 'Welcome to Flora Web',
                onAction: async () => {
                    await authService.login(authorization);
                    dispatch(setRegistrationForm({}));
                    history.push('/courseAnnouncement');
                }
            });
        } catch (e) {
            prompt.alert(e, {title:'Failed to registration.'});
        }
    }

    const title = STEPS[activeStep];
    const Form = FORMS[activeStep];

    const responsive = useResponsive();
    const isMobile = responsive.isSmallScreen() || responsive.isMediumScreen();


    return (
        <Paper position="relative" fullWidth fullHeight>
            <Box position="absolute" top={0} left={0} fullWidth fullHeight backgroundColor="black" backgroundOpacity={0.9} >
                <HomeImage />
            </Box>
            <Box display={isMobile?'none':'flex'} justifyContent="center" gap={4} position="absolute"  width="80%" height='80%' left="10%" top="10%">
                <Paper className={clsx(classes.form, classes.transparent)} variant="outlined" >
                    <Form value={value} onChange={handleChange}
                          onNext={handleNext} onBack={handleBack}
                          onComplete={handleComplete}
                          title={title}
                    />
                </Paper>
                <Paper className={clsx(classes.stepper, classes.transparent)}   variant="outlined" >
                    <RegistrationStepper activeStep={activeStep} />
                </Paper>
            </Box>
            <Paper display={isMobile?'block':'none'} padding={3} fullHeight fullWidth className={classes.transparent} variant="outlined" >
                <Form value={value} onChange={handleChange}
                      onNext={handleNext} onBack={handleBack}
                      onComplete={handleComplete}
                      title={title}
                />
            </Paper>
        </Paper>
    );
}

function RegistrationForm_0(props) {
    const [agreement, setAgreement] = useState(null);

    const history = useHistory();

    useEffect(() => {
        (async () => {
            const agreement = await enrollmentService.findAgreement();
            setAgreement(agreement);
        })();
    }, []);


    const handleClose = () => {
        history.push('/');
    }

    const router = useRouter();
    const handleSignInInstead = () => router.login();
    return (
        <Box fullHeight fullWidth display='flex' flexDirection='column'>
            <Box fullWidth paddingY={1}>
                <Typography variant='h5'>{i18n.translate('Release of Personal Information Agreement')}</Typography>
            </Box>
            <Box fullWidth padding={1} overflow='auto' border='1px solid black'>
                <RichText value={agreement} fullWidth disabled/>
            </Box>
            <Form value={props.value} onChange={props.onChange}>
                <FormGroup>
                    <FormControlLabel label={i18n.translate('Agreement 1')} name="agreement" control={<Checkbox required/>} />
                </FormGroup>
            </Form>
            <Space spacing={2} vertical/>
            <Box display="flex" justifyContent="space-between" paddingTop={1}>
                {/*<Button text="Close" color="secondary" onClick={handleClose} />*/}
                <Button text="Sign in instead" color="secondary" onClick={handleSignInInstead} />
                <Button text="Next" variant="contained" color="primary" onClick={props.onNext} disabled={!props.value.agreement} />
            </Box>
        </Box>
    )

}

function RegistrationForm_1(props) {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    }

    const handleShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    }
    const classes = useStyles();
    const router = useRouter();
    const handleSignInInstead = () => router.login();

    return (
        <Box fullWidth fullHeight display='flex' flexDirection='column' overflow='hidden'>
            <Box marginBottom={2}>
                <Typography variant="h5">{i18n.translate(props.title)}</Typography>
            </Box>
            <Box fullWidth fullHeight overflow='auto' paddingTop={1}>
                <Form value={props.value} onChange={props.onChange}>
                    <Grid container spacing={2} item xs={12}>
                        <Grid item xs={12}>
                            <TextField name="chineseName" label="Chinese Name" variant="outlined" helperText='書寫範例：王小華'
                                       fullWidth required/>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField name="englishFirstName" label="English First Name" variant="outlined" helperText='English First Name Sample'
                                       fullWidth required/>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField name="englishLastName" label="English Last Name" variant="outlined" helperText='English Last Name Sample'
                                       fullWidth required/>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField name="email" label="Email" variant="outlined" helperText='This is a member account and cannot be modified after registration.'
                                       fullWidth required/>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                name="password"
                                label="Password"
                                variant="outlined"
                                fullWidth
                                type="password"
                                required
                                type={showPassword? "text" : "password"}
                                autoComplete="current-password"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleShowPassword}>
                                                { showPassword? <Visibility/> : <VisibilityOff/> }
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}/>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                name="confirmPassword"
                                label="Confirm Password"
                                variant="outlined"
                                fullWidth
                                type="password"
                                required
                                type={showConfirmPassword? "text" : "password"}
                                autoComplete="current-password"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleShowConfirmPassword}>
                                                { showConfirmPassword? <Visibility/> : <VisibilityOff/> }
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}/>
                        </Grid>
                        <Grid item xs={12}>
                            <Box paddingX={1.5} marginTop={-1.5}>
                                <Typography variant="body2" color="textSecondary">{i18n.translate('Please contain at least 8 characters, including English uppercase and lowercase letters, numbers and symbols')}</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Form>
            </Box>
            <Box display="flex" justifyContent="space-between" paddingTop={1}>
                {/*<Button text="Sign in instead" color="secondary" onClick={handleSignInInstead} />*/}
                <Button text="Back" color="secondary" onClick={props.onBack} />
                <Button text="Next" variant="contained" color="primary" onClick={props.onNext} />
            </Box>
        </Box>
    )
}

function RegistrationForm_2(props) {
    return (
        <Box fullWidth fullHeight display='flex' flexDirection='column' overflow='hidden'>
            <Box marginBottom={2}>
                <Typography variant="h5">{i18n.translate(props.title)}</Typography>
            </Box>
            <Box fullWidth fullHeight overflow='auto' paddingTop={1}>
                <Form value={props.value} onChange={props.onChange}>
                    <Grid container spacing={2} item xs={12}>
                        <Grid item xs={12}>
                            <TextField name="mobilePhone" label="Mobile Phone" variant="outlined" fullWidth required/>
                        </Grid>
                        <Grid item xs={12}>
                            <Address name='mailingAddress' subtitle='Mailing Address' required/>
                        </Grid>
                    </Grid>

                </Form>
            </Box>
            <Box display="flex" justifyContent="space-between" paddingTop={2}>
                <Button text="Back" color="secondary" onClick={props.onBack} />
                <Button text="Next" variant="contained" color="primary" onClick={props.onNext}/>
            </Box>
        </Box>
    )
}

function Address(props){
    const {subtitle, value={}, required} = props;
    const county = useSelector(selectCounty);
    const towns = county.find(item => item.code===value.county)?.towns;

    const handleChange = (event) => {
        const {value, change} = event;
        const {county, town} = change;
        let newValue = {...value};
        if(lang.isNotUndefined(county)) {
            newValue = {...value, town:null, zip:null};
        }
        if(lang.isNotUndefined(town)) {
            const zip = towns.find(item => item.code===value.town)?.zip;
            newValue = {...value, zip};
        }
        for(let key in newValue) {
            if(lang.isNotNullOrUndefined(newValue[key])) {
                props.onChange(new UserEvent({value:newValue}));
                return;
            }
        }
        props.onChange(new UserEvent({value: null}));
    };

    return (
        <Form value={value} onChange={handleChange}>
            {subtitle &&
                <Typography variant="subtitle1" gutterBottom color="textSecondary" required={required}>
                    {i18n.translate(subtitle)}
                </Typography>
            }
            <Grid  container spacing={2}>
                <Grid item xs={6}>
                    <SelectField name="county" label='City' variant='outlined' options={county} valueAccessor='code' textAccessor='name' required={required} />
                </Grid>
                <Grid item xs={6}>
                    <SelectField name="town" label='District' variant="outlined" options={towns} valueAccessor='code' textAccessor='name' fullWidth required={required} />
                </Grid>
                <Grid item xs={12}>
                    <TextField name="street" label='Street' variant="outlined" fullWidth required={required} />
                </Grid>
                <Grid item xs={6}>
                    <TextField name="zip" label='ZIP' variant="outlined" fullWidth />
                </Grid>
            </Grid>
        </Form>
    );
}

function RegistrationForm_3(props) {
    const { value } = props;
    const prompt = usePrompt();

    const handleRequestToken = async () => {
        try {
            await registrationService.requestToken(value.email);
            prompt.info('Open the email and find the verification code.');
        } catch(e) {
            prompt.alert('Failed to send the verification code.\nPlease try again later.');
        }
    }

    const handleVerifyEmail = async () => {
        try {
            const valid = await registrationService.verifyEmail(value.email, value.token);
            if(valid) {
                props.onChange(new UserEvent({
                    value : {...value, valid: true}
                }));
            }
        } catch(e) {
            prompt.alert('Failed to verify the email.\nPlease try again later.');
        }
    }

    return (
        <Box fullWidth fullHeight display='flex' flexDirection='column' overflow='hidden'>
            <Box marginBottom={2}>
                <Typography variant="h5">{i18n.translate(props.title)}</Typography>
            </Box>
            <Box fullWidth fullHeight overflow='auto' paddingTop={1}>
                <Form value={value} onChange={props.onChange}>
                    <Grid container spacing={1} item xs={12}>
                        <Grid item xs={12}>
                            <Box marginBottom={2} display='flex' flexDirection='column' >
                                <Button text="Click to get the verification code." color="primary" variant ="contained" onClick={handleRequestToken} />
                                <Typography variant="caption" color="textSecondary" style={{marginTop: '0.3rem', marginLeft: '0.8rem'}}>{i18n.translate('Click Send button, the system will send the verification code to your email.')}</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={8}>
                            <TextField name="token" label="Verification Code" variant="outlined"
                                       fullWidth size="small" required
                                       helperText="Please enter the verification code received by email"/>
                        </Grid>
                        <Grid item xs={12}>
                            <Box marginTop={2} display='flex' flexDirection='column' >
                                <Box>
                                    <Button color={"secondary"} text="Verify" variant="contained" onClick={handleVerifyEmail} />
                                    <Checkbox disabled name="valid" />
                                </Box>
                                <Typography variant="caption" color="textSecondary" style={{marginTop: '0.3rem', marginLeft: '0.8rem'}}>{i18n.translate('Please press the verify button to confirm correctness.')}</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box marginTop={3} marginBottom={3}  padding={1}>
                        <Typography>{i18n.translate('Welcome ......')}</Typography>

                    </Box>
                </Form>
            </Box>
            <Box display="flex" justifyContent="space-between" paddingTop={1}>
                <Button text="Back" color="secondary" onClick={props.onBack} />
                <Button text="Complete" variant="contained" color="primary" onClick={props.onComplete}/>
            </Box>
        </Box>

    )
}

function RegistrationStepper(props) {
    const {activeStep} = props;
    const steps = STEPS;

    return (
        <Stepper activeStep={activeStep} orientation="vertical">
            {steps.map((label, index) => (
                <Step key={label}>
                    <StepLabel><Typography>{i18n.translate(label)}</Typography></StepLabel>
                    <StepContent>
                        <Typography>{i18n.translate(getStepContent(index))}</Typography>
                    </StepContent>
                </Step>
            ))}
        </Stepper>
    );
}

export default withExplorer(Registration);